module.exports = __webpack_public_path__ + "static/media/dec_logo.a42748f8.svg";